export const privacyLevelMessage = {
  icon: 'locked',
  text: 'Individual data is locked',
};

export const insufficientDataMessage = {
  icon: 'missing_data',
  text: 'Insufficient data',
};
